(function event(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  const previousEvent = global.NewHomeSource.Event;

  /**
   * private
   * addEvent: appends a event listener to the given element.
   *
   * @param {string} name of the event being added.
   * @param {function} callback that is going to be executed.
   */
  function addEvent(name, callback) {
    this.addEventListener(name, callback, false);
  }

  /**
   * private
   * processCallbacks: loops through the callbacks that are going to be append.
   *
   * @param {HTMLElement} element that is going to listen for the event.
   * @param {string} name of the event being added.
   */
  function processCallbacks(element, name) {
    this.callbacks.forEach(addEvent.bind(element, name));
  }

  /**
   * private
   * processEvents: loops through the events that are going to be appended.
   *
   * @param {HTMLElement} element that is going to listen for the event.
   */
  function processEvents(element) {
    this.events.forEach(processCallbacks.bind(this, element));
  }

  /**
   * private
   * processConfiguration: loops through the configuration object in order to append the events.
   *
   * @param {string} property being processed.
   */
  function processConfiguration(property) {
    const setter = this[property];
    const elements = global.document.querySelectorAll(setter.elements);

    elements.forEach(processEvents.bind(setter));
  }

  /**
   * @constructs NewHomeSource.Event
   *
   * @param {object} configuration events that are going to be attached.
   */
  function Event(configuration) {
    Object.keys(configuration).forEach(processConfiguration.bind(configuration));
  }

  /**
   * @public
   *
   * clickElement: trigger click element on the document
   *
   * @param {object} element to click.
   */
  Event.clickElement = function clickElement (element) {
    if (element) {
      element.click();
    }
  }

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewer to the previous script.
   */
  Event.noConflict = function noConflict() {
    global.NewHomeSource.Event = previousEvent;
    return Event;
  };

  global.NewHomeSource.Event = Event;
}(window));
